import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './SiteLabelsForm.styles';

import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';
import FormGroup from '../formgroup/FormGroup';

export class SiteLabelsForm extends Component {
	render() {
		return (
			<AddForm onSubmit={this.props.handleSubmit} styles={styles.siteLabelForm}>
				<div className={css(styles.infoHeader)}>
					<Translate value="edit.labels.info" />
					<div className={css(styles.note)}><Translate value="edit.labels.note" /></div>
				</div>
				<FormGroup>

					<Field
						name="labels.tag"
						label={I18n.t('models.site.labels.tag')}
						type="text"
						placeholder={I18n.t('models.site.labels.tag')}
						component={FormField}
						maxLength="200"
					/>



					<Field
						name="labels.group"
						label={I18n.t('models.site.labels.group')}
						type="text"
						placeholder={I18n.t('models.site.labels.group')}
						component={FormField}
						maxLength="200"
					/>


					<Field
						name="labels.category"
						label={I18n.t('models.site.labels.category')}
						type="text"
						placeholder={I18n.t('models.site.labels.category')}
						component={FormField}
						maxLength="200"
					/>


					<Field
						name="labels.field1"
						label={I18n.t('models.site.labels.field1')}
						type="text"
						placeholder={I18n.t('models.site.labels.field1')}
						component={FormField}
						maxLength="200"
					/>


					<Field
						name="labels.field2"
						label={I18n.t('models.site.labels.field2')}
						type="text"
						placeholder={I18n.t('models.site.labels.field2')}
						component={FormField}
						maxLength="200"
					/>
				</FormGroup>
				<FormActions>
					<Button>{I18n.t('add.save')}</Button>
					<Button
						styles={styles.flatButton}
						type="button"
						onClick={this.props.onCancel}
					>
						{I18n.t('cancel')}
					</Button>
				</FormActions>
			</AddForm >
		);
	}
}

export default reduxForm({
	form: 'sitelabels'
})(SiteLabelsForm);



// WEBPACK FOOTER //
// ./src/components/forms/sitelabelsform/SiteLabelsForm.js